import RadioCardListPage from "@components/RadioCardListPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

const OPTIONS = [
  { emoji: "🌟", key: "inspired" },
  { emoji: "😮", key: "impressed" },
  { emoji: "😄", key: "happy" },
  { emoji: "🤨", key: "intrigued" },
  { emoji: "💝", key: "connected" },
]

const HOME_OPTIONS = [
  { emoji: "🤗", key: "warmWelcome" },
  { emoji: "😮", key: "wowed" },
  { emoji: "🧘", key: "atEase" },
  { emoji: "✨", key: "inspired" },
  { emoji: "🏠", key: "atHome" },
]

export default function SharePhotoPage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="sharePhotoHomeDesign"
        options={HOME_OPTIONS}
      />
    )
  }
  return <RadioCardListPage translationKey="sharePhoto" options={OPTIONS} />
}
